export default __webpack_public_path__ + "static/media/P30003.4112878c.png";